import { useState } from "react";
import axios from "axios";
import { TextField, Button, Box, Typography, Snackbar, Grid, Alert } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import HomeIcon from "@mui/icons-material/Home";
import Table from "./NotificationTable";

const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

const AddNotificationForm = () => {
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post("https://admin.bizstor.lk/public/api/notifications", {
                title,
                message,
            });
            setSnackbarMessage(response.data.message);
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
            setTitle("");
            setMessage("");
        } catch (error) {
            setSnackbarMessage("Failed to add notification.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };

    return (
        <Box
        sx={{mt:10}}
        >
            <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 },
                    mt: { xs: 2, sm: 3 },
                    letterSpacing: "0.01em",
                    fontSize: { xs: "20px", sm: "24px" },
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <HomeIcon sx={{ ml: 1, fontSize: "18px", color: "#6d7081" }} />
                    <Typography component="span" sx={{ ml: 0.5, fontSize: "14px", color: "#6d7081" }}>
                        - Add Notification
                    </Typography>
                </Box>
            </AnimatedTypography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '95%',
                    maxWidth: 'auto',
                    margin: 'auto',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative',
                    '@media (max-width: 600px)': {
                        marginTop: '10px',
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        "@media (max-width: 600px)": { margin: "auto" },
                        color: "#6d7081",
                        ml: 2,
                    }}
                >
                    <h2>Add Notification</h2>
                </Box>

                <Box sx={{ m: 2 }}>
                    <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                label="Title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                variant="outlined"
                                fullWidth
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                label="Message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                variant="outlined"
                                fullWidth
                                size="small"
                                multiline
                                rows={4}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        sx={{
                            backgroundColor: "#4287f5",
                            color: "white",
                            marginTop: "30px",
                            borderRadius: "20px",
                            padding: "8px 24px",
                            "&:hover": { backgroundColor: "#356bc4" },
                        }}
                    >
                        Add Notification
                    </Button>
                </Box>
            </Box>

            <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
                <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
            </Snackbar>
            <Table/>
        </Box>
    );
};

export default AddNotificationForm;
